import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56dd6608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-self-end justify-content-center bottom-0 w-full footer p-3" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {

const openUrl = function (url: string) {
	window.open(url)
}
// @ is an alias to /src

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!
  const _component_p_button = _resolveComponent("p-button")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_p_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openUrl('https://www.linkedin.com/in/airidas-dapkevicius-69411723/'))),
      class: "mx-1 p-button-rounded p-button-primary p-button-outlined"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_fa, { icon: ['fab', 'linkedin'] })
      ]),
      _: 1
    })
  ]))
}
}

})